// Formats a "HH:MM" or "HH:MM:SS" time string (as returned by Postgres TIME
// columns, or produced by <input type="time">) as "8:00 AM".
export function formatTime12h(timeStr) {
  if (!timeStr) return '';
  const [h, m] = timeStr.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, '0')} ${period}`;
}
